const addItemToArray = (array, index, item) => array.slice(0, index).concat([item]).concat(array.slice(index));
export default addItemToArray;